<template>
    <div class="order-price-label">
        <PricesWithCommission
            :order-prices="priceInSystemCurrency"
            :title="$t('price')"
            :is-show-v-a-t-commission="isShowVATCommission"
            :vat-calculated-amount-by-each-service-netto="vatCalculatedAmountByEachServiceNetto"
            :show-commission-and-netto-block="showCommissionAndNettoBlock"
        >
            <v-tooltip v-if="showConvertPrices" v-model="show" location="top" width="260">
                <template v-slot:activator="{props}">
                    <v-btn
                        v-bind="props"
                        size="small"
                        icon="mdi-cash-multiple"
                        variant="text"
                        density="compact"
                        color="grey"
                        class="mx-2 mb-2"
                        data-cy="show-currency-multiple"
                        @click="show = !show"
                    />
                </template>
                <PricesWithCommission
                    :order-prices="orderPrices"
                    :is-show-v-a-t-commission="isShowVATCommission"
                    :vat-calculated-amount-by-each-service-netto="vatCalculatedAmountByEachServiceNetto"
                    :show-commission-and-netto-block="showCommissionAndNettoBlock"
                />
            </v-tooltip>
        </PricesWithCommission>
        <v-row
            v-if="$conf.public.account.paymentScheduler"
            no-gutters
            class="commission-block align-center justify-space-between flex-wrap gc-4 gr-2"
        >
            <slot />
            <payment-status-label class="ml-auto" :status="paymentStatus" />
        </v-row>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import PriceLabel from '~src/components/snippets/priceLabel.src'
    import PaymentStatusLabel from '~src/components/account/snippets/paymentStatusLabel.src'
    import CancelPenaltyLabel from '@/components/snippets/CancelPenaltyLabel.vue'
    import PricesWithCommission from '~/components/account/snippets/PricesWithCommission.vue'

    @Component({components: {PricesWithCommission, CancelPenaltyLabel, PaymentStatusLabel, PriceLabel}})
    export class OrderPriceLabel extends Vue {
        @Prop({required: true}) orderPrices
        @Prop({required: true}) services
        @Prop({required: true}) paymentStatus
        @Prop({required: true}) showCommissionAndNettoBlock
        @Prop({required: true}) vatCalculatedAmountByEachServiceNetto

        show = false

        get isShowVATCommission() {
            return true
        }

        get showConvertPrices() {
            return persistentStore.showConvertPrices && this.orderPrices?.length > 1
        }

        get priceInSystemCurrency() {
            if (this.showConvertPrices) {
                let prices = []
                const totalPrice = calcTotalPrice(this.orderPrices)
                const totalPriceInSystemCurrency = convertPrice(totalPrice, authStore.systemCurrency)
                prices.push(totalPriceInSystemCurrency)
                return prices
            }
            return this.orderPrices
        }
    }

    export default OrderPriceLabel
</script>
<style lang="scss" scoped>
    @use 'vuetify/settings';
    @use 'sass:map';

    //TODO[p4] remove settings for white tooltip in all components
    .v-tooltip :deep(.v-overlay__content) {
        background-color: white;
        color: black;
        box-shadow: 0 6px 10px rgba(0, 0, 0, 0.25);
    }
</style>
